/** Exam-countdown pill. The page only renders this when `days` is a real
 *  positive number derived from `lib/exam-date.ts` (EXAM_DATE is null by
 *  default → the page omits the chip entirely). No fabricated count. */
export function CountChip({ days }: { days: number }) {
  return (
    <>
      {/* Desktop: compact pill with the number in accent + calendar glyph. */}
      <span className="hidden lg:inline-flex items-center gap-2.5 rounded-full border border-[var(--border)] bg-[var(--panel)] py-2 pl-4 pr-2 shadow-[var(--shadow)]">
        <span className="font-display font-semibold text-[17px] text-[var(--accent)]">
          {days} dagen
        </span>
        <span className="grid h-[34px] w-[34px] place-items-center rounded-full bg-[var(--accent-soft)] text-[var(--accent)]">
          <CalendarGlyph size={17} />
        </span>
      </span>

      {/* Mobile: full-sentence variant. */}
      <span className="inline-flex items-center gap-2 rounded-full border border-[var(--border)] bg-[var(--panel)] px-3.5 py-1.5 text-[13px] font-semibold text-[var(--accent)] lg:hidden">
        <CalendarGlyph size={14} />
        Examen over {days} dagen
      </span>
    </>
  );
}

function CalendarGlyph({ size }: { size: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      aria-hidden
    >
      <rect x="3" y="4" width="18" height="17" rx="2" />
      <path d="M3 9h18M8 2v4M16 2v4" />
    </svg>
  );
}
